class TrackingGroupService {
    static generateKey({ domain, locationId }) {
        return `${domain}_${locationId}`;
    }
}

export default TrackingGroupService;
